(() => {
  angular
    .module("akitabox.ui.dialogs.asset.costLineSelection")
    .component("abxCostLineCreationSection", {
      bindings: {
        setInvalid: "<abxSetInvalid",
        onCustomCostLineDataChange: "<abxOnCustomCostLineDataChange",
        existingCostLine: "<abxExistingCostLine",
      },
      controllerAs: "vm",
      controller: AbxCostLineCreationSectionController,
      templateUrl:
        "app/core/ui/dialogs/asset/cost-line-selection/creation-section/cost-line-creation-section.component.html",
    });

  /* @ngInject */
  function AbxCostLineCreationSectionController(patterns) {
    const _private = {};
    // =================
    // Properties
    // =================

    /**
     * @public
     * @type { string } Form state for uniformat field
     */
    this.uniformat = "";

    /**
     * @public
     * @type { string } Form state for description field
     */
    this.description = "";

    /**
     * Customization form data
     */
    this.formData = {};

    // =================
    // Lifecycle
    // =================

    this.$onChanges = (changes) => {
      if (changes.existingCostLine && this.existingCostLine) {
        _private.populateFormFromExistingCostLine();
      }
    };

    // ================
    // Utils
    // ================
    const validityMap = {
      uniformat: false,
      description: false,
      formData: true,
    };

    _private.populateFormFromExistingCostLine = () => {
      if (!this.existingCostLine) {
        return;
      }
      this.validityMap = {
        uniformat: true,
        description: true,
        formData: true,
      };

      this.formData = {
        quantity: this.existingCostLine.quantity,
        baseCost: this.existingCostLine.total_cost,
        costPerUnit: this.existingCostLine.unit_cost,
        unit: this.existingCostLine.quantity_unit,
      };

      this.uniformat = this.existingCostLine.uniformat;
      this.description = this.existingCostLine.description;

      _private.emitCostLineData();
    };

    _private.emitCostLineData = () => {
      this.onCustomCostLineDataChange({
        model: {
          uniformat: this.uniformat,
          description: this.description,
          baseCost: this.formData.baseCost,
          quantity: this.formData.quantity,
          costPerUnit: this.formData.costPerUnit,
          unit: this.formData.unit,
        },
        invalid: !_private.isValid(validityMap),
      });
    };

    const pattern = new RegExp(patterns.CUSTOM_UNIFORMAT, "i");
    _private.isValidUniformat = (uniformat) => pattern.test(uniformat);

    this.getInvalidMessage = () => {
      if (!_private.isValidUniformat(this.uniformat)) {
        return "Uniformat can only consist of letters and numbers.";
      }
    };

    _private.isValid = (validityMap) => {
      return (
        validityMap.uniformat && validityMap.description && validityMap.formData
      );
    };

    // =================
    // Event Handlers
    // =================
    this.handleUniformatChange = ({ model, invalid }) => {
      this.setInvalid(!_private.isValid(validityMap));
      validityMap.uniformat = !invalid || _private.isValidUniformat(model);
      this.uniformat = model;
      _private.emitCostLineData();
    };

    this.handleDescriptionChange = ({ model, invalid }) => {
      this.setInvalid(!_private.isValid(validityMap));
      validityMap.description = !invalid;
      this.description = model;
      _private.emitCostLineData();
    };

    this.handleFormDataChange = ({ model, invalid }) => {
      this.setInvalid(!_private.isValid(validityMap));
      validityMap.formData = !invalid;
      this.formData = model;
      _private.emitCostLineData();
    };
  }
})();
